// extracted by mini-css-extract-plugin
export default {"flex":"index_flex__oX32K"};